import { CURRENT_CONFIG } from './config.js';
export const api = {
  async getCategories() {
    try {
      const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/content/category`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
          'Accept-Encoding': 'gzip, deflate, br',
          'Connection': 'keep-alive'
        }
      })
      const result = await response.json()
      if (result.code === 200) {
        return result.data
      }
      throw new Error(result.msg || '获取分类失败')
    } catch (error) {
      console.error('获取分类失败:', error)
      throw error
    }
  },

  async getArticles(categoryId, title = '', pageNum = 1, pageSize = 10, top = false) {
            try {
              const params = new URLSearchParams({
                categoryId: categoryId.toString(),
                title: title,
                top: top,
                pageNum: pageNum.toString(),
                pageSize: pageSize.toString()
              })
              if (top === false) {
                params.delete('top')
              }
              const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/content/?${params}`, {
                method: 'GET',
                headers: {
                  'Accept': '*/*',
                  'Accept-Encoding': 'gzip, deflate, br',
                  'Connection': 'keep-alive'
                }
              })
              const result = await response.json()
              if (result.code === 200) {
                return {
                  rows: result.rows || [],
                  total: result.total || 0
                }
              }
              throw new Error(result.msg || '获取文章列表失败')
            } catch (error) {
              console.error('获取文章列表失败:', error)
              throw error
            }
          },

          async getArticleDetail(articleId) {
            try {
              const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/content/${articleId}`, {
                method: 'GET',
                headers: {
                  'Accept': '*/*',
                  'Accept-Encoding': 'gzip, deflate, br',
                  'Connection': 'keep-alive'
                }
              })
              const result = await response.json()
              if (result.code === 200) {
                return result.data
              }
              throw new Error(result.msg || '获取文章详情失败')
            } catch (error) {
              console.error('获取文章详情失败:', error)
              throw error
            }
          },

          async getMemberDetail(companyId) {
            try {
              const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/company/instruction?companyId=${companyId}`, {
                method: 'GET',
                headers: {
                  'Accept': '*/*',
                  'Accept-Encoding': 'gzip, deflate, br',
                  'Connection': 'keep-alive'
                }
              })
              const result = await response.json()
              if (result.code === 200) {
                return result.data
              }
              throw new Error(result.msg || '获取企业详情失败')
            } catch (error) {
              console.error('获取企业详情失败:', error)
              throw error
            }
          },

          async getMembersNew(pageNum) {
            try {
              // 获取新会员数据
              const newMembersData = await this.getVipList('NEW_MEMBER', 8, pageNum)

              return {
                newMembersData
              }
            } catch (error) {
              console.error('获取会员数据失败:', error)
              // 加载失败时使用默认数据
              // return {
              //   councilMembers: [
              //     { icon: 'https://picsum.photos/seed/member1/200/200', title: '会员企业名称1' },
              //     { icon: 'https://picsum.photos/seed/member2/200/200', title: '会员企业名称2' },
              //     { icon: 'https://picsum.photos/seed/member3/200/200', title: '会员企业名称3' },
              //     { icon: 'https://picsum.photos/seed/member4/200/200', title: '会员企业名称4' },
              //     { icon: 'https://picsum.photos/seed/member5/200/200', title: '会员企业名称5' },
              //     { icon: 'https://picsum.photos/seed/member6/200/200', title: '会员企业名称6' },
              //     { icon: 'https://picsum.photos/seed/member7/200/200', title: '会员企业名称7' },
              //     { icon: 'https://picsum.photos/seed/member8/200/200', title: '会员企业名称8' }
              //   ],
              //   newMembers: [
              //     { icon: 'https://picsum.photos/seed/newmember1/200/200', title: '新会员企业1' },
              //     { icon: 'https://picsum.photos/seed/newmember2/200/200', title: '新会员企业2' },
              //     { icon: 'https://picsum.photos/seed/newmember3/200/200', title: '新会员企业3' },
              //     { icon: 'https://picsum.photos/seed/newmember4/200/200', title: '新会员企业4' },
              //     { icon: 'https://picsum.photos/seed/newmember5/200/200', title: '新会员企业5' }
              //   ]
              // }
            }
    },
          async getMembersDirector(pageNum) {
            try {
              // 获取理事单位数据
              const councilMembersData = await this.getVipList('DIRECTOR', 8, pageNum)
              return {
                councilMembersData,
              }
            } catch (error) {
              console.error('获取会员数据失败:', error)
              // 加载失败时使用默认数据
              // return {
              //   councilMembers: [
              //     { icon: 'https://picsum.photos/seed/member1/200/200', title: '会员企业名称1' },
              //     { icon: 'https://picsum.photos/seed/member2/200/200', title: '会员企业名称2' },
              //     { icon: 'https://picsum.photos/seed/member3/200/200', title: '会员企业名称3' },
              //     { icon: 'https://picsum.photos/seed/member4/200/200', title: '会员企业名称4' },
              //     { icon: 'https://picsum.photos/seed/member5/200/200', title: '会员企业名称5' },
              //     { icon: 'https://picsum.photos/seed/member6/200/200', title: '会员企业名称6' },
              //     { icon: 'https://picsum.photos/seed/member7/200/200', title: '会员企业名称7' },
              //     { icon: 'https://picsum.photos/seed/member8/200/200', title: '会员企业名称8' }
              //   ],
              //   newMembers: [
              //     { icon: 'https://picsum.photos/seed/newmember1/200/200', title: '新会员企业1' },
              //     { icon: 'https://picsum.photos/seed/newmember2/200/200', title: '新会员企业2' },
              //     { icon: 'https://picsum.photos/seed/newmember3/200/200', title: '新会员企业3' },
              //     { icon: 'https://picsum.photos/seed/newmember4/200/200', title: '新会员企业4' },
              //     { icon: 'https://picsum.photos/seed/newmember5/200/200', title: '新会员企业5' }
              //   ]
              // }
            }
          },


  async getBanners(type = 'head') {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/banner?type=${type}`, {
          method: 'GET',
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Connection': 'keep-alive'
          }
        })
        const result = await response.json()
        if (result.code === 200) {
          return result.rows || []
        }
        throw new Error(result.msg || '获取轮播图失败')
      } catch (error) {
        console.error('获取轮播图失败:', error)
        throw error
      }
    },

    async getVipList(vipType, pageSize, pageNum) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/vip/list?vipType=${vipType}&pageSize=${pageSize}&pageNum=${pageNum}`, {
          method: 'GET',
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Connection': 'keep-alive'
          }
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        }
        throw new Error(result.msg || '获取会员列表失败')
      } catch (error) {
        console.error('获取会员列表失败:', error)
        throw error
      }
    },

    async getDisplayCount(id = 1) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/display-count?id=${id}`, {
          method: 'GET',
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Connection': 'keep-alive',
            'Content-Type': 'application/json'
          }
        })
        const result = await response.json()
        if (result.code === 200) {
          return result.data
        }
        throw new Error(result.msg || '获取访问量失败')
      } catch (error) {
        console.error('获取访问量失败:', error)
        throw error
      }
    },

    async incrementDisplayCount(id = 1) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/display-count/${id}/increment`, {
          method: 'POST',
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Connection': 'keep-alive',
            'Content-Type': 'application/json'
          }
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        }
        throw new Error(result.msg || '增加访问量失败')
      } catch (error) {
        console.error('增加访问量失败:', error)
        throw error
      }
    },

    async validateCredentials(username, password) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/validate-credentials`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ username, password })
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        }
        throw new Error(result.msg || '校验账号密码失败')
      } catch (error) {
        console.error('校验账号密码失败:', error)
        throw error
      }
    },

    async validateUsername(username) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/validate-username`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*'
          },
          body: JSON.stringify({ username })
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        }
        throw new Error(result.msg || '校验用户名失败')
      } catch (error) {
        console.error('校验用户名失败:', error)
        throw error
      }
    },

    async sendSmsCode(username, phone) {
      const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/captchaSms?username=${username}&contactMobile=${phone}`, {
        method: 'GET',
        headers: {
          'Accept': '*/*'
        }
      })
      const result = await response.json()
      return result
    },

    async login(username, password, code, uuid, phoneNumber) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ username, password, code, uuid, phoneNumber })
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        }
        throw new Error(result.msg || '登录失败')
      } catch (error) {
        console.error('登录失败:', error)
        throw error
      }
    },

    async register(username, password, code, uuid, contactName, contactMobile) {
      const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/user/system/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*'
        },
        body: JSON.stringify({ username, password, code, uuid, contactName, contactMobile })
      })
      const result = await response.json()
      return result
    },

    async getUserRole(username) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/user/role?userName=${username}`, {
          method: 'GET',
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Connection': 'keep-alive'
          }
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        } else if (result.code === 500) {
          return result
        }
        throw new Error(result.msg || '获取用户角色失败')
      } catch (error) {
        console.error('获取用户角色失败:', error)
        throw error
      }
    },
    // 查询数字产品列表
    async getDigitalProducts(productName, category, domain, pageNum, pageSize) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/digital-product/list-product?productName=${productName}&category=${category}&domain=${domain}&pageNum=${pageNum}&pageSize=${pageSize}`, {
          method: 'GET',
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Connection': 'keep-alive'
          }
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        } else if (result.code === 500) {
          return result
        }
        throw new Error(result.msg || '查询数字产品列表失败')
      } catch (error) {
        console.error('查询数字产品列表失败:', error)
        throw error
      }
    },
    // 获取产品详情
    async getProductDetailApi(productId) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/digital-product/product/${productId}`, {
          method: 'GET',
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Connection': 'keep-alive'
          }
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        } else if (result.code === 500) {
          return result
        }
        throw new Error(result.msg || '查询数字产品详情失败')
      } catch (error) {
        console.error('查询数字产品详情失败:', error)
        throw error
      }
    },
    // 获取典型案例
    async getProductCaseListApi() {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/portal/digital-product/list-case`, {
          method: 'GET',
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Connection': 'keep-alive'
          }
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        } else if (result.code === 500) {
          return result
        }
        throw new Error(result.msg || '获取典型案例失败')
      } catch (error) {
        console.error('获取典型案例失败:', error)
        throw error
      }
    },
    // 获取数据字典
    async getDataDictApi(dictType) {
      try {
        const response = await fetch(`${CURRENT_CONFIG.BASE_URL}/system/dict/data/list?pageNum=1&pageSize=${100}&dictType=${dictType}`, {
          method: 'GET',
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Connection': 'keep-alive'
          }
        })
        const result = await response.json()
        if (result.code === 200) {
          return result
        } else if (result.code === 500) {
          return result
        }
        throw new Error(result.msg || '获取数据字典失败')
      } catch (error) {
        console.error('获取数据字典失败:', error)
        throw error
      }
    }
}
